import axios from "@/plugins/axios";

let url = "/api/console/nshop/orders";

/** @typedef {import('../../../../store/nshop').NshopOrder} $NshopOrder */

export const orders = {
    /**
     * @param {import("axios").AxiosRequestConfig} data
     * @returns {Promise<{ summary: { totalCount: number }, orders: $NshopOrder[]}>}
     */
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },

    /**
     * @param {{ _id: string }} data
     * @returns {Promise<{ order: $NshopOrder }>}
     */
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },

    /**
     * @param {Partial<$NshopOrder>} data
     * @returns {Promise<{ order: $NshopOrder }>}
     */
    put(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },

    resend: {
        /**
         * @param {{ _id: string }} data
         * @returns {Promise<{ order: $NshopOrder }>}
         */
        post(data) {
            return axios.post(`${url}/${data._id}/resend`, data).then((result) => result.data);
        },
    },

    cancel: {
        /**
         * 결제취소(환불) — 나누리핀 폐기 + 쿠콘 540 취소.
         * @param {{ _id: string }} data
         * @returns {Promise<{ order: $NshopOrder }>}
         */
        post(data) {
            return axios.post(`${url}/${data._id}/cancel`, data).then((result) => result.data);
        },
    },

    cancelMark: {
        /**
         * 취소표기 — 결제사에서 이미 환불된 주문을 환불 호출 없이 취소완료(ORDER_CANCEL)로 바꾼다.
         * voidPins 가 true 면 충전하지 않은 핀을 나누리핀에서 폐기한다.
         * @param {{ _id: string, voidPins: boolean }} data
         * @returns {Promise<{ order: $NshopOrder }>}
         */
        post(data) {
            return axios.post(`${url}/${data._id}/cancel-mark`, data).then((result) => result.data);
        },
    },
};

export default orders;
